import { ApiAccessEffects } from "./api-access.effect";
import { BusinessClassificationEffects } from "./business-classification.effects";
import { ConsumerEffects } from "./consumer.effects";
import { AchAddEffects } from "./consumer/ach-add.effects";
import { ConsumerAccountRemoveEffects } from "./consumer/consumer-account-remove.effects";
import { ConsumerAccountUpdateEffects } from "./consumer/consumer-account-update.effects";
import { ConsumerActionItemsEffects } from "./consumer/consumer-action-items.effects";
import { ConsumerUserResendEmailEffects } from "./consumer/consumer-user-resend-email.effects";
import { ContractConsumerFundingDetailsEffects } from "./consumer/contract-consumer-funding-details.effects";
import { ConsumerDailyStatsEffects } from "./consumer/daily-stats.effects";
import { DataPerProductStatsGetEffects } from "./consumer/data-per-product-stats-get.effects";
import { FundingBalanceGetEffects } from "./consumer/funding-balance-get.effects";
import { OrderCostStatsGetEffects } from "./consumer/order-cost-stats-get.effects";
import { StatsEffects } from "./consumer/stats.effects";
import { VendorGroupsEffects } from "./consumer/vendor-groups.effects";
import { ConsumerAchEffects } from "./consumer-ach.effects";
import { ActiveVendorOwnersGetEffects } from "./consumer-admin/active-vendor-owners-get.effects";
import { BoUpdateEffects } from "./consumer-admin/bo-update.effects";
import { ConsumerAchRemoveEffects } from "./consumer-admin/consumer-ach-remove.effects";
import { ConsumerAchUpdateEffects } from "./consumer-admin/consumer-ach-update.effects";
import { ConsumerRolesGetEffects } from "./consumer-admin/consumer-roles-get.effects";
import { ConsumerUserCreateEffects } from "./consumer-admin/consumer-user-create.effects";
import { ConsumerUserRemoveEffects } from "./consumer-admin/consumer-user-remove.effects";
import { ConsumerUserRoleUpdateEffects } from "./consumer-admin/consumer-user-role-update.effects";
import { ConsumerUsersGetEffects } from "./consumer-admin/consumer-users-get.effects";
import { CreditCardChargeEffects } from "./consumer-admin/credit-card-charge.effects";
import { AchBoStatusEffects } from "./consumer-transaction/ach-bo-status.effects";
import { AchDocumentEffects } from "./consumer-transaction/ach-document.effects";
import { AchStatusEffects } from "./consumer-transaction/ach-status.effects";
import { DataTransactionsGetEffects } from "./data-transaction/data-transactions-get.effects";
import { EditProposalEffects } from "./exchange/edit-proposal.effects";
import { ExchangeProposalGetEffects } from "./exchange/exchange-proposal-get.effects";
import { ExchangeProposalsGetEffects } from "./exchange/exchange-proposals-get.effects";
import { ProposalCreateEffects } from "./exchange/proposal-create.effects";
import { VendorProposalsByProductGetEffects } from "./exchange/proposals-by-product.effects";
import { HrrEffects } from "./hrr/hrr.effects";
import { MessagingEffects } from "./messaging/messaging.effects";
import { MpAdminEffects } from "./mp-admin.effects";
import { AccountRequestsGetEffects } from "./mp-admin/account-requests-get.effects";
import { ActivityCountsEffects } from "./mp-admin/activity-counts.effects";
import { AddFundsToFBOAccountEffects } from "./mp-admin/add-funds-to-fbo-account.effects";
import { BillableProposalsEffects } from "./mp-admin/billable-proposals-effects";
import { ComplianceRegimeEffects } from "./mp-admin/compliance-regime-effects";
import { ConsumerActivateEffects } from "./mp-admin/consumer-activate.effects";
import { ConsumerBalancesEffects } from "./mp-admin/consumer-balances.effects";
import { ConsumerDenyEffects } from "./mp-admin/consumer-deny.effects";
import { ConsumerDistributionKeysEffects } from "./mp-admin/consumer-distribution-keys.effects";
import { AdminConsumerFundsGetEffects } from "./mp-admin/consumer-funds.effects";
import { ConsumerProposalsEffects } from "./mp-admin/consumer-proposals.effects";
import { AdminConsumerStatsGetEffects } from "./mp-admin/consumer-stats.effects";
import { ConsumerStatusEffects } from "./mp-admin/consumer-status-effects";
import { AdminConsumerUserRemoveEffects } from "./mp-admin/consumer-user-remove.effects";
import { AdminConsumerUsersEffects } from "./mp-admin/consumer-users.effects";
import { ConsumerVerificationUpdateEffects } from "./mp-admin/consumer-verification-update.effects";
import { ConsumersGetEffects } from "./mp-admin/consumers-get.effects";
import { AdminDailyStatsGetEffects } from "./mp-admin/daily-stats.effects";
import { DataRightsAdminEffects } from "./mp-admin/data-rights-admin.effects";
import { DataTransactionsGetMpAdminEffects } from "./mp-admin/data-transactions-get-mp-admin.effects";
import { ExcessProposalFundsEffects } from "./mp-admin/excess-proposal-funds.effects";
import { FamilyAttributesEffects } from "./mp-admin/family-attributes.effects";
import { InvoicesEffects } from "./mp-admin/invoices-effects";
import { MarketplaceBalanceEffects } from "./mp-admin/marketplace-balance-effects";
import { MonitoringRegimeDefaultsEffects } from "./mp-admin/monitoring-regime-defaults.effects";
import { MonitoringTiersEffects } from "./mp-admin/monitoring-tiers.effects";
import { ProductAttributesAdminEffects } from "./mp-admin/product-attributes-admin.effects";
import { ProductCategoriesEffects } from "./mp-admin/product-categories.effects";
import { ProductFamiliesEffects } from "./mp-admin/product-families.effects";
import { ProductStandardListsEffects } from "./mp-admin/product-standard-lists.effects";
import { ProductsEffects } from "./mp-admin/products.effects";
import { AdminStatsGetEffects } from "./mp-admin/stats.effects";
import { VendorActivateEffects } from "./mp-admin/vendor-activate.effects";
import { VendorDenyEffects } from "./mp-admin/vendor-deny.effects";
import { AdminVendorStatsGetEffects } from "./mp-admin/vendor-stats.effects";
import { VendorStatusEffects } from "./mp-admin/vendor-status-effects";
import { AdminVendorUserRemoveEffects } from "./mp-admin/vendor-user-remove.effects";
import { AdminVendorUsersEffects } from "./mp-admin/vendor-users.effects";
import { VendorVerificationUpdateEffects } from "./mp-admin/vendor-verification-update.effects";
import { AdminVendorsGetEffects } from "./mp-admin/vendors-get.effects";
import { ActiveVendorsGetEffects } from "./mp-common/active-vendors-get.effects";
import { CountryEffects } from "./mp-common/country.effects";
import { CurrencyGetEffects } from "./mp-common/currency-get.effects";
import { DataRightsGetEffects } from "./mp-common/data-rights-get.effects";
import { DistributionKeyGetEffects } from "./mp-common/distribution-key-get.effects";
import { OnOrbitCountryEffects } from "./mp-common/on-orbit-country.effects";
import { RfPolarizationEffects } from "./mp-common/rf-polarization-get.effects";
import { RfSignalsGetEffects } from "./mp-common/rf-signals-get.effects";
import { TagsEffects } from "./mp-common/tags.effects";
import { VendorsGetEffects } from "./mp-common/vendors-get.effects";
import { OnOrbitEffects } from "./on-orbit/on-orbit.effects";
import { OnOrbitOrderGetEffects } from "./on-orbit/on-orbit-order-get.effects";
import { ConsumerOnboardingEffects } from "./onboarding/consumer-onboarding.effect";
import { VendorOnboardingEffects } from "./onboarding/vendor-onboarding.effect";
import { VendorRatingsGetEffects } from "./open/vendor-ratings-get.effects";
import { VendorReviewsGetEffects } from "./open/vendor-reviews-get.effects";
import { AcceptProposalEffects } from "./order-proposal/accept-proposal.effects";
import { CancelOrderProposalEffects } from "./order-proposal/cancel-proposal.effects";
import { DeclineOrderProposalEffects } from "./order-proposal/decline-proposal.effects";
import { OrderProposalsGetEffects } from "./order-proposal/order-proposals-get.effects";
import { ProposalsByProductGetEffects } from "./order-proposal/proposal-by-product.effects";
import { ProposalFinancialGetEffects } from "./order-proposal/proposal-financial-get.effects";
import { ProposalGetEffects } from "./order-proposal/proposal-get.effects";
import { ProposalsGetEffects } from "./order-proposal/proposals-get.effects";
import { ReorderProposalEffects } from "./order-proposal/reorder-proposal.effects";
import { SkipOrderProposalEffects } from "./order-proposal/skip-proposal.effect";
import { VendorReviewCreateEffects } from "./order-proposal/vendor-review-create.effects";
import { ProductTreeEffects } from "./product-tree.effects";
import { PublicEffects } from "./public.effects";
import { PurchaseOrderEffects } from "./purchase-order.effects";
import { RouterEffects } from "./router.effects";
import { UserEffects } from "./user.effects";
import { UserPreferencesGetEffects } from "./user-prefs/user-prefs-get.effects";
import { UserPreferencesUpdateEffects } from "./user-prefs/user-prefs-update.effects";
import { VendorEffects } from "./vendor.effects";
import { BankTemplateGetEffects } from "./vendor/bank-template-get.effects";
import { BeneficiaryCreateEffects } from "./vendor/beneficiary-create.effects";
import { VendorDailyStatsEffects } from "./vendor/daily-stats.effects";
import { VendorAccountGetEffects } from "./vendor/vendor-account-get.effects";
import { VendorAccountRemoveEffects } from "./vendor/vendor-account-remove.effects";
import { VendorAccountUpdateEffects } from "./vendor/vendor-account-update.effects";
import { VendorActionItemsEffects } from "./vendor/vendor-action-items.effects";
import { VendorStatsEffects } from "./vendor/vendor-stats-get.effects";
import { VendorUpdateAgreementSigningStatusEffects } from "./vendor/vendor-update-agreement-signing-status.effects";
import { VendorUserResendEmailEffects } from "./vendor/vendor-user-resend-email.effects";
import { VendorAchEffects } from "./vendor-ach.effects";
import { VendorAchRemoveEffects } from "./vendor-admin/vendor-ach-remove.effects";
import { VendorAchUpdateEffects } from "./vendor-admin/vendor-ach-update.effects";
import { VendorDeleteInternationalBankAccountEffects } from "./vendor-admin/vendor-delete-international-bank-account.effects";
import { VendorLogoUploadEffects } from "./vendor-admin/vendor-logo-upload.effects";
import { VendorRolesGetEffects } from "./vendor-admin/vendor-roles-get.effects";
import { VendorUserCreateEffects } from "./vendor-admin/vendor-user-create.effects";
import { VendorUserRemoveEffects } from "./vendor-admin/vendor-user-remove.effects";
import { VendorUserRoleUpdateEffects } from "./vendor-admin/vendor-user-role-update.effects";
import { VendorUsersGetEffects } from "./vendor-admin/vendor-users-get.effects";
import { VendorSupportedProductsEffects } from "./vendor-supported-products.effects";

export const rootEffects = [
	PublicEffects,
	AcceptProposalEffects,
	ReorderProposalEffects,
	AchAddEffects,
	AchBoStatusEffects,
	AchDocumentEffects,
	AchStatusEffects,
	ActiveVendorOwnersGetEffects,
	ActiveVendorsGetEffects,
	ActivityCountsEffects,
	AddFundsToFBOAccountEffects,
	AdminConsumerStatsGetEffects,
	AdminStatsGetEffects,
	AdminDailyStatsGetEffects,
	AdminVendorStatsGetEffects,
	AdminConsumerUsersEffects,
	AdminVendorsGetEffects,
	AdminVendorUsersEffects,
	ApiAccessEffects,
	BankTemplateGetEffects,
	BeneficiaryCreateEffects,
	BoUpdateEffects,
	BusinessClassificationEffects,
	CancelOrderProposalEffects,
	ConsumerAccountRemoveEffects,
	AccountRequestsGetEffects,
	ConsumerAccountUpdateEffects,
	ConsumerAchEffects,
	ConsumerAchRemoveEffects,
	ConsumerAchUpdateEffects,
	ConsumerActionItemsEffects,
	ConsumerActivateEffects,
	ConsumerBalancesEffects,
	ConsumerDailyStatsEffects,
	ConsumerDenyEffects,
	ConsumerEffects,
	AdminConsumerFundsGetEffects,
	ConsumerProposalsEffects,
	ConsumerRolesGetEffects,
	ConsumersGetEffects,
	ContractConsumerFundingDetailsEffects,
	ConsumerUserCreateEffects,
	ConsumerUserRemoveEffects,
	ConsumerUserResendEmailEffects,
	ConsumerUserRoleUpdateEffects,
	ConsumerUsersGetEffects,
	ConsumerVerificationUpdateEffects,
	CountryEffects,
	CreditCardChargeEffects,
	CurrencyGetEffects,
	DataPerProductStatsGetEffects,
	DataRightsGetEffects,
	DataTransactionsGetEffects,
	DataTransactionsGetMpAdminEffects,
	DeclineOrderProposalEffects,
	DistributionKeyGetEffects,
	ExcessProposalFundsEffects,
	ExchangeProposalGetEffects,
	ExchangeProposalsGetEffects,
	EditProposalEffects,
	FundingBalanceGetEffects,
	MarketplaceBalanceEffects,
	MessagingEffects,
	MpAdminEffects,
	OnOrbitCountryEffects,
	OnOrbitEffects,
	HrrEffects,
	OnOrbitOrderGetEffects,
	OrderCostStatsGetEffects,
	OrderProposalsGetEffects,
	ProductTreeEffects,
	ProposalCreateEffects,
	ProposalFinancialGetEffects,
	ProposalGetEffects,
	ProposalsGetEffects,
	ProposalsByProductGetEffects,
	RfPolarizationEffects,
	RfSignalsGetEffects,
	RouterEffects,
	SkipOrderProposalEffects,
	StatsEffects,
	TagsEffects,
	UserEffects,
	UserPreferencesGetEffects,
	UserPreferencesUpdateEffects,
	VendorAccountGetEffects,
	VendorAccountUpdateEffects,
	VendorAccountRemoveEffects,
	VendorUpdateAgreementSigningStatusEffects,
	VendorAchEffects,
	VendorAchRemoveEffects,
	VendorAchUpdateEffects,
	VendorActionItemsEffects,
	VendorActivateEffects,
	VendorDailyStatsEffects,
	VendorDeleteInternationalBankAccountEffects,
	VendorDenyEffects,
	VendorEffects,
	VendorGroupsEffects,
	VendorLogoUploadEffects,
	VendorRatingsGetEffects,
	VendorReviewCreateEffects,
	VendorReviewsGetEffects,
	VendorRolesGetEffects,
	VendorsGetEffects,
	VendorProposalsByProductGetEffects,
	VendorStatsEffects,
	VendorUserCreateEffects,
	VendorUserRemoveEffects,
	VendorUserResendEmailEffects,
	VendorUserRoleUpdateEffects,
	VendorUsersGetEffects,
	VendorVerificationUpdateEffects,
	AdminConsumerUserRemoveEffects,
	AdminVendorUserRemoveEffects,
	VendorOnboardingEffects,
	ConsumerOnboardingEffects,
	BillableProposalsEffects,
	InvoicesEffects,
	VendorStatusEffects,
	ConsumerStatusEffects,
	ProductFamiliesEffects,
	ProductCategoriesEffects,
	ProductsEffects,
	FamilyAttributesEffects,
	ProductAttributesAdminEffects,
	MonitoringTiersEffects,
	MonitoringRegimeDefaultsEffects,
	ProductStandardListsEffects,
	DataRightsAdminEffects,
	ConsumerDistributionKeysEffects,
	PurchaseOrderEffects,
	VendorSupportedProductsEffects,
	ComplianceRegimeEffects
];
